module.exports = __webpack_public_path__ + "img/1401.8d68455b.gif";